import { Fragment, useContext } from "react"
import { ModuleContext } from "../context/ModuleContext"
import { ValidateIdentity } from "../operations/ValidateIdentity";
import { Dialog, DialogContent, IconButton, styled } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
      padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
      padding: theme.spacing(1),
    },
  }));


export const ModuleContainer = () =>{

    const {module, setModule} = useContext(ModuleContext);

    const onClose = (event, reason) => {

      if(reason && reason === "backdropClick"){
        return;
      }

      setModule((prev) => ({...prev, isVisible: false, element: null, userId: null}));

    }


    if(!module.validated && !module.isLog){
        if(module.validationError){
            return(
                <div>
                    <p>
                        {module.validationError}
                    </p>
                </div>
            )
        }else{
            return ( <Fragment>
                <BootstrapDialog
                  onClose={onClose}
                  aria-labelledby="customized-dialog-title"
                  open={module.isVisible}
                >
                  <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={(theme) => ({
                      position: 'absolute',
                      right: 8,
                      top: 8,
                      color: theme.palette.grey[500],
                    })}
                  >
                    <CloseIcon />
                  </IconButton>
                  <DialogContent style={{padding: "30px"}}>
                    <ValidateIdentity userId={module.userId}/>
                  </DialogContent>
                </BootstrapDialog>
              </Fragment>);
        }

    }else{
        return ( <Fragment>
            <BootstrapDialog
                onClose={onClose}
                aria-labelledby="customized-dialog-title"
                open={module.isVisible}
                maxWidth={"xl"}
                fullWidth
                PaperProps={{
                    sx: {
                        width: "fit-content",
                        minWidth: "60vw",
                    }
                }}
            >
              <IconButton
                aria-label="close"
                onClick={onClose}
                sx={(theme) => ({
                  position: 'absolute',
                  right: 8,
                  top: 8,
                  color: theme.palette.grey[500],
                })}
              >
                <CloseIcon />
              </IconButton>
              <DialogContent style={{padding: "60px"}}>
                {module.element}
              </DialogContent>
            </BootstrapDialog>
          </Fragment>);
    } 
}